<template>
  <table>
    <caption>대상자별 통계</caption>
    <thead class="table_list_head table_list_head_line">
      <tr>
        <th class="center" rowspan="2">날짜</th>
        <th class="center" colspan="2">일반소식</th>
        <th class="center" colspan="2">반복소식</th>
        <th class="center">맞춤소식</th>
        <th class="center" colspan="3">두뇌톡톡</th>
        <th class="center" colspan="2">기억검사</th>
        <th class="center">좋은생각</th>
        <th class="center">마음체조</th>
      </tr>
      <tr>
        <th class="center">전송</th>
        <th class="center">확인</th>
        <th class="center">전송</th>
        <th class="center">확인</th>
        <th class="center">전송</th>
        <th class="center">평균점수</th>
        <th class="center">호출</th>
        <th class="center">완료</th>
        <th class="center">호출</th>
        <th class="center">완료</th>
        <th class="center">호출</th>
        <th class="center">호출</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="rowData in sourceList">
        <td>{{rowData.date}}</td>
        <td class="right">{{rowData.newsNormalRequestCount}}</td>
        <td class="right">{{rowData.newsNormalReadCount}}</td>
        <td class="right">{{rowData.newsRepeatRequestCount}}</td>
        <td class="right">{{rowData.newsRepeatReadCount}}</td>
        <td class="right">{{rowData.newsCustomRequestCount}}</td>
        <td class="right">{{rowData.gameAvgScore}}</td>
        <td class="right">{{rowData.gameStartCount}}</td>
        <td class="right">{{rowData.gameFinalCount}}</td>
        <td class="right">{{rowData.dementiaStartCount}}</td>
        <td class="right">{{rowData.dementiaFinalCount}}</td>
        <td class="right">{{rowData.goodStartCount}}</td>
        <td class="right">{{rowData.mindStartCount}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    sourceList: Array
  }
};
</script>

<style>
</style>